<template>
    <button id="REWIND" name="REWIND" class="btn" data-vcode="REWIND">
        <img src="/images/icons/rewind.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('rewindButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
